import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../app/store";

const initialState = [
  { name: "user1", isAdmin: false, email: "user1@bbgo.com" },
  { name: "user2", isAdmin: true, email: "user2@bbgo.com" },
];

export const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setAdmin: (state, action) => {
      const selectedUser = state.find((user) => user.email === action.payload);
      if (selectedUser) {
        selectedUser.isAdmin = true;
      }
    },
  },
});

export const { setAdmin } = userSlice.actions;
export const users = (state: RootState) => state.user;
export default userSlice.reducer;
